export const themes = [
  {
    name: 'Default',
    light: {
      primary: '#320359',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#52088F',
      info: '#984b00',
      warning: '#F1852F',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff5252'
    }
  },
  {
    name: 'Blue',
    light: {
      primary: '#7365ff',
      accent: '#eae7f3',
      secondary: '#FFFFFF',
      success: '#52088F',
      info: '#e97500',
      warning: '#F1852F',
      error: '#ff5e3c'
    },
    dark: {
      primary: '#E65100',
      accent: '#7CB342',
      secondary: '#689F38',
      success: '#4CAF50',
      info: '#6156d8',
      warning: '#1565C0',
      error: '#FF7043'
    }
  },
  {
    name: 'langimmobilien',
    light: {
      primary: '#008da8',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#008da8',
      info: '#4b4b4d',
      warning: '#4b4b4d',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff5252'
    }
  },
  {
    name: 'ivv',
    light: {
      primary: '#8f9248',
      accent: '#e8f1e6',
      secondary: '#e8f1e6',
      success: '#8f9248',
      info: '#8f9248',
      warning: '#8f9248',
      error: '#e82424'
    },
    dark: {
      primary: '#e8f1e6',
      accent: '#e8f1e6',
      secondary: '#607D8B',
      success: '#FFEB3B',
      info: '#2196F3',
      warning: '#9C27B0',
      error: '#B71C1C'
    }
  },
  {
    name: 'talyo',
    light: {
      primary: '#204143',
      accent: '#e8f1e6',
      secondary: '#204143',
      success: '#d4f6b9',
      info: '#ffffff',
      warning: '#204143',
      error: '#e82424'
    },
    dark: {
      primary: '#33691E',
      accent: '#b5e576',
      secondary: '#607D8B',
      success: '#FFEB3B',
      info: '#2196F3',
      warning: '#9C27B0',
      error: '#B71C1C'
    }
  },
  {
    name: 'newwaysrealestate',
    light: {
      primary: '#4ebbe0',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#4ebbe0',
      info: '#4b4b4d',
      warning: '#4b4b4d',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff5252'
    }
  },
  {
    name: 'cordesbruns',
    light: {
      primary: '#320359',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#52088F',
      info: '#984b00',
      warning: '#F1852F',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff5252'
    }
  },
  {
    name: 'phi',
    light: {
      primary: '#9C0000',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#9C0000',
      info: '#4b4b4d',
      warning: '#4b4b4d',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff5252'
    }
  },
  {
    name: 'immotrades',
    light: {
      primary: '#ff4e18',
      accent: '#F7F5F5',
      secondary: '#FFFFFF',
      success: '#ff4e18',
      info: '#4b4b4d',
      warning: '#4b4b4d',
      error: '#000000'
    },
    dark: {
      primary: '#22daff',
      accent: '#ff6b99',
      secondary: '#26ff8c',
      success: '#a5d64c',
      info: '#ff53d0',
      warning: '#ff8e99',
      error: '#ff4e18'
    }
  }
]
